module.exports = __webpack_public_path__ + "static/media/esoko.17e8ab32.svg";